module.exports = __webpack_public_path__ + "fonts/FilsonPro-Black.5ef9327.woff";